import {URL_BASE_API } from '../configs/urlConfigs' 

import service from './api';

export const cancelReasonsMasterList = (request) => {
    const ENDPOINT  = URL_BASE_API+'super-admin/cancelled-reasons/';
    return service.get(ENDPOINT); 
}; 

export const cancelReasonsMasterAdd = (request) => {
    const ENDPOINT  = URL_BASE_API+'super-admin/cancelled-reasons/';
    return service.post(ENDPOINT,request.data); 
};

export const cancelReasonsMasterLoad = (request) => {
    const ENDPOINT  = URL_BASE_API+'super-admin/cancelled-reasons/'+request.data.cancelReasonId; 
    return service.get(ENDPOINT); 
};

export const cancelReasonsMasterModify = (request) => {
    const ENDPOINT  = URL_BASE_API+'super-admin/cancelled-reasons/'+request.data.id; 
    return service.put(ENDPOINT,{name:request.data.name}); 
};

export const cancelReasonsMasterDelete = (request) => {
    const ENDPOINT  = URL_BASE_API+'super-admin/cancelled-reasons/'+request.data.id; 
    return service.delete(ENDPOINT); 
}; 

export const cancelReasonsList = (request) => {
    const ENDPOINT  = URL_BASE_API+'affiliate/aff-cancelled-reasons/';
    return service.get(ENDPOINT); 
}; 

export const cancelReasonsAdd = (request) => {
    const ENDPOINT  = URL_BASE_API+'affiliate/aff-cancelled-reasons/';
    return service.post(ENDPOINT,request.data); 
};

export const cancelReasonsLoad = (request) => {
    const ENDPOINT  = URL_BASE_API+'affiliate/aff-cancelled-reasons/'+request.data.cancelReasonId; 
    return service.get(ENDPOINT); 
};

export const cancelReasonsModify = (request) => {
    const ENDPOINT  = URL_BASE_API+'affiliate/aff-cancelled-reasons/'+request.data.id; 
    return service.put(ENDPOINT,{name:request.data.name}); 
};

export const cancelReasonsDelete = (request) => {
    const ENDPOINT  = URL_BASE_API+'affiliate/aff-cancelled-reasons/'+request.data.id; 
    return service.delete(ENDPOINT); 
};

